exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3[data-v-59f6c252] {\n  font-weight: normal;\n  margin-top: 12px !important;\n}\n.ajuste[data-v-59f6c252] {\n  padding-bottom: 16px;\n}\n", ""]);

// exports
